<template>
  <div>
    <v-container grid-list-md>
      <!-- <v-layout row wrap> -->
      <v-data-table :headers="headers" :items="users" sort-by="Name" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>{{(!id)?'Organization Users':'Users'}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <!-- <v-btn color="primary" dark class="ma-1" @click="dialog=true;">New User</v-btn> -->
            <v-btn color="primary" dark class="ma-1" @click="addUserClick">Add User</v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.confirmed="{ item }">{{(item.confirmed)?'Yes':'No'}}</template>

        <template v-slot:item.createdAt="{ item }">{{new Date(item.createdAt).toLocaleDateString()}}</template>
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
          <v-icon small @click="deleteItem(item)">delete</v-icon>
        </template>
        <template v-slot:no-data>There are no users.</template>
      </v-data-table>
    </v-container>
    <!--  New User Dialog-->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field v-model="editedItem.name" label="Name"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="editedItem.phone" label="Phone"></v-text-field>
                <v-input
                  hint="A verification text will be sent this this number when added."
                  persistent-hint
                ></v-input>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Existing User dialog -->
    <v-dialog v-model="existdialog" scrollable max-width="500px">
      <v-card>
        <v-toolbar flat color="white">
          <v-toolbar-title>Organization Users</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- <v-btn color="primary" dark class="ma-1" @click="dialog=true;">New User</v-btn> -->
          <v-btn color="primary" dark class="ma-1" @click="addUserClick">New User</v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;">
          <v-layout wrap>
            <v-flex xs12>
              <v-checkbox
                v-for="globaluser in globalusers"
                v-bind:key="globaluser._id"
                v-model="selectedUsers"
                :label="globaluser.name"
                color="primary"
                :value="globaluser._id"
                hide-details
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="existdialog = false">Close</v-btn>
          <v-btn
            :color="(selectedUsers.length != 0)?'blue darken-1':'grey'"
            text
            :disabled="selectedUsers.length == 0"
            @click="addGroupUsers"
          >Add Users</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-loading :dialog="isLoading" />
  </div>
</template>
<script>
import userService from "@/services/admin/user";
import groupService from "@/services/groups/users";
import groupsVue from "./groups.vue";
export default {
  props: ["id"],
  data: () => ({
    dialog: false,
    existdialog: false,
    isLoading: false,
    selectedUsers: [],
    globalusers: [],
    headers: [
      {
        text: "Name",
        align: "left",
        sortable: true,
        value: "name"
      },
      { text: "Phone", value: "phone" },
      { text: "Confirmed", value: "confirmed", sortable: true },
      { text: "Added", value: "createdAt", sortable: true },
      { text: "Actions", sortable: false, align: "right", value: "action" }
    ],
    users: [],
    editedIndex: -1,
    editedItem: {
      name: "",
      phone: ""
    },
    defaultItem: {
      name: "",
      phone: ""
    }
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New User" : "Edit User";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    id() {
      this.initialize();
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    addUserClick() {
      console.log("Click");
      if (!this.id || (this.id && this.existdialog)) {
        this.dialog = true;
        this.existdialog = false;
      } else {
        this.existdialog = true;
        this.dialog = false;
      }
    },
    initialize() {
      this.isLoading = true;
      userService
        .getAllUsers()
        .then(users => {
          console.log(users);
          if (!this.id) {
            this.users = users;
            return Promise.resolve([]);
          } else {
            this.globalusers = users;
            return groupService.getAllUsers(this.id);
          }
        })
        .then(data => {
          console.log(data);
          if (this.id) {
            this.users = data;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
          console.log(err);
        });
    },

    editItem(item) {
      this.editedIndex = this.users.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      console.log(this.id);
      let prompt = `Are you sure you want to remove ${item.name} from this group?`;
      if (this.id == undefined) {
        prompt = `Are you sure you want to remove ${item.name}?\n\nThis will remove them from every group.`;
      }
      if (!confirm(prompt)) {
        return;
      }
      this.isLoading = true;
      Promise.resolve()
        .then(_ => {
          if (this.id) {
            return groupService.removeUser(item._id, this.id);
          } else {
            return userService.removeUser(item._id);
          }
        })
        .then(data => {
          this.isLoading = false;
          this.initialize();
        })
        .catch(err => {
          this.isLoading = false;
        });
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      Promise.resolve()
        .then(_ => {
          if (this.editedIndex > -1) {
            return userService.editUser(
              this.users[this.editedIndex]._id,
              this.editedItem.name,
              this.editedItem.phone
            );
          } else {
            return userService.addUser(
              this.editedItem.name,
              this.editedItem.phone
            );
          }
        })
        .then(data => {
          if (this.id && !(this.editedIndex > -1)) {
            // this.selectedUsers = [data._id]
            return groupService.addUser(data._id, this.id);
          } else {
            console.log("Just simple.");
            return Promise.resolve();
          }
        })
        .then(data => {
          console.log(data);
          this.initialize();
          this.close();
        })
        .catch(err => {
          console.log(err);
        });
    },
    addGroupUsers() {
      if (!this.id || this.selectedUsers.length == 0) {
        return;
      }
      this.dialog = false;
      this.existdialog = false;
      this.isLoading = true;
      groupService
        .bulkAddUser(this.selectedUsers, this.id)
        .then(data => {
          this.isLoading = false;
          console.log(data);
          this.initialize();
        })
        .catch(err => {
          this.isLoading = false;
          console.log(err);
        });
    }
  }
};
</script>